export const searchFormOption = function () {
    return [
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '请输入工号/手机号/姓名'
        },
        {
            prop: 'org_id',
            label: '所属机构',
            type: 'cascader',
            placeholder: '请选择所属机构',
            propConfig: {
                children: "children",
                label: "orgName",
                value: "id",
                checkStrictly: true,
                emitPath: false,
            },
            options: this.orgOption
        },
        {
            prop: 'is_enabled',
            label: '状态',
            type: 'select',
            options: [{
                label: '全部',
                value: ''
            },
            {
                label: '正常',
                value: 0
            },
            {
                label: '禁用',
                value: 1
            }
            ]
        },
        {
            prop: 'user_type',
            label: '用户类型',
            type: 'select',
            options: [{
                label: '全部',
                value: ''
            },
            {
                label: '普通员工',
                value: '普通员工'
            },
            {
                label: '业务员',
                value: '业务员'
            }
            ]
        },
    ]
}

export default {}